var ShippingMethod = /* @__PURE__ */ ((ShippingMethod2) => {
  ShippingMethod2["Delivery"] = "home-delivery";
  ShippingMethod2["DeliveryExpress"] = "home-delivery-express";
  ShippingMethod2["NearestPickup"] = "nearest-pick-up";
  ShippingMethod2["Pickup"] = "pick-up";
  ShippingMethod2["PickupPoint"] = "pick-up-point";
  ShippingMethod2["DeliveryPremium"] = "dpd-priority-delivery";
  ShippingMethod2["DeliveryResponsible"] = "home-delivery-responsible";
  return ShippingMethod2;
})(ShippingMethod || {});
export {
  ShippingMethod
};
//# sourceMappingURL=shipping-methods.js.map
